import React from 'react'
import {useEffect, useState} from 'react'
import envVariables from '../../data/envVariables'
import Button from '../Button'
import { isDealPreAvinode } from '../../utilities/settings'

const PortalSalesStageBasedCtas = ({deal, firstLeg, onShowOptions}) => { 
    const legId = deal.daM_Ref
    const pricesUrl = `${envVariables.documentBase}/prices?lo=${legId}&currency=6`
    const builderUrl = `${envVariables.documentBase}/QuoteBuilder?lo=${legId}&currency=6&regenerate=true`
    //const optionsUrl = `/quote?lo=${legId}`
    const avinodeUrl = firstLeg.quotes ?? ''
    const downloadQuoteBriefUrl = `${envVariables.documentBase}/QuotebuilderDownload/download-quotebrief?lo=${legId}`
    const downloadInvoiceUrl = `${envVariables.documentBase}/api/invoice/download-invoice-jsr?legId=${legId}`
    const quotePageUrl = `/quote?lo=${legId}`
    const addPaxUrl = `/add-passengers-to-booking/${legId}`
    const briefUrl = `/flight-brief?lo=${legId}`
    const briefPdfUrl = `${envVariables.documentBase}/api/invoice/final-brief?legId=${legId}&view=report`

    const contractUrl = deal.contract_link
    const contractDownloadUrl = deal.download_contract_public

    const pb1InvoicePdf = deal.post_Booking_Invoice_1_URL
    const pb2InvoicePdf = deal.post_Booking_Invoice_2_URL
    const pb3InvoicePdf = deal.post_Booking_Invoice_3_URL

    const paymentUrl = deal.payment_Page_URL

    useEffect(() => {
        //console.log(deal)
    }, [deal, firstLeg])

    const openPricesPage = () => {
        window.location.href = pricesUrl
    }
    
    const openQuoteBuilder = () => {
        window.location.href = builderUrl
    }

    const openOptionsPage = () => {
        window.open(avinodeUrl)
    }

    const openInvoiceDL = () => {
        window.open(downloadInvoiceUrl, '_blank')
    }

    const openContractPdf = () => {
        window.open(contractDownloadUrl, '_blank')
    }

    const openContractPage = () => {
        window.location.href = contractUrl
    }

    const openQuotePage = () => {
        window.open(quotePageUrl, '_blank')
    }

    const openAddPax = () => {
        window.open(addPaxUrl, '_blank')
    }

    const openBriefPage = () => {
        window.open(briefUrl, '_blank')
    }

    const openBriefPdf = () => {
        window.open(briefPdfUrl, '_blank')
    }
    
    const openPbInvoice1Pdf = () => {
        window.open(pb1InvoicePdf, '_blank')
    }
    const openPbInvoice2Pdf = () => {
        window.open(pb2InvoicePdf, '_blank')
    }
    const openPbInvoice3Pdf = () => {
        window.open(pb3InvoicePdf, '_blank')
    }
    const openPaymentPage = () => {
        window.open(paymentUrl, '_blank')
    }

    return (
        <>
            <div className="portal-cta-grid">   
                {(!isDealPreAvinode(deal) && firstLeg.quotes) && <Button classNames={['button button--secondary']} onClick={openOptionsPage}>Marketplace</Button>}
                {(!isDealPreAvinode(deal)) && <Button classNames={['button button--secondary']} onClick={openPricesPage}>Prices page</Button>}
                {(!isDealPreAvinode(deal)) && <Button classNames={['button button--secondary']} onClick={openQuoteBuilder}>Quote builder</Button>}
                
                {(!isDealPreAvinode(deal)) && 
                    <>
                        <a href={downloadQuoteBriefUrl} download>
                            <Button classNames={['button button--secondary']}>Quote PDF</Button>
                        </a>
                        <Button classNames={['button button--secondary']} onClick={onShowOptions}>Preview Quote</Button>
                        <Button classNames={['button button--secondary']} onClick={openQuotePage}>Quote page</Button>     
                    </>
                }

                {(!isDealPreAvinode(deal)) && 
                    <>
                        <Button classNames={['button button--secondary']} onClick={openContractPdf}>Contract PDF</Button>
                        <Button classNames={['button button--secondary']} onClick={openContractPage}>Contract Page</Button>           
                    </>
                }
                {(!isDealPreAvinode(deal)) && deal.payment_Page_URL && 
                <Button classNames={['button button--secondary']} onClick={openPaymentPage}>Payment page</Button>    
                }

                {(!isDealPreAvinode(deal)) && 
                <>
                    <Button classNames={['button button--secondary']} onClick={openInvoiceDL}>Invoice PDF</Button>  
                </>
                }

                {(!isDealPreAvinode(deal)) && 
                    <>
                        <Button classNames={['button button--secondary']} onClick={openBriefPage}>Brief Page</Button>   
                        <Button classNames={['button button--secondary']} onClick={openBriefPdf}>Brief PDF</Button>
                    </>
                }
                 
                {(!isDealPreAvinode(deal)) && 
                    <>
                        <Button classNames={['button button--secondary']} onClick={openAddPax}>Add Pax</Button>   
                    </>
                }
                
                {(!isDealPreAvinode(deal)) && deal.additional_Flight_Costs_Number &&
                    <>
                        <Button classNames={['button button--secondary']} onClick={openPbInvoice1Pdf}>PB Invoice 1 PDF</Button>   
                    </>
                }
                {(!isDealPreAvinode(deal)) && deal.post_booking_Invoice_2_Price_number && 
                    <>
                        <Button classNames={['button button--secondary']} onClick={openPbInvoice2Pdf}>PB Invoice 2 PDF</Button>   
                    </>
                }
                {(!isDealPreAvinode(deal)) && deal.post_booking_Invoice_3_Price_number && 
                    <>
                        <Button classNames={['button button--secondary']} onClick={openPbInvoice3Pdf}>PB Invoice 3 PDF</Button>   
                    </>
                }
            </div>
            
        </>
    )
}

export default PortalSalesStageBasedCtas